import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { EUserType } from '../enums/EUserType';

@Injectable({
    providedIn: 'root',
})
export class RootG implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router,
    ) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authService.gUser && this.authService.gUser._id && this.authService.gUser.usr_type_str === EUserType.ROOT) {
            return true;
        } else {
            this.router.navigate(['login']);
            return false;
        }
    }
}
